import {Component, OnInit} from '@angular/core';
import {UserRolesRestService} from '../shared/services/userrole/user-roles-rest.service';
import {SelectItem} from 'primeng/api';
import {UserRole} from '../shared/types/userrole/user-role';
import {GlobalMessagesService} from '../shared/services/messages/global.messages.service';
import {TranslateService} from '@ngx-translate/core';
import {SecurityService} from '../shared/services/security/security.service';
import {SystemType} from '../shared/types/common/system-type';
import {
  ADMINISTRATION_LABELS,
  NDP_PERMISSION_LABELS,
  ORG_PERMISSION_LABELS,
  PERSON_PERMISSION_LABELS,
  NDP_READ_ONLY_PERMISSIONS, NDP_UPDATE_ONLY_PERMISSIONS,
  NDP_NOT_CREATE_PERMISSIONS, NDP_NOT_DELETE_PERMISSIONS,
  READ_ONLY_ADMINISTRATION_LABELS
} from '../shared/types/permission/permission-labels';

@Component({
  selector: 'wsd-user-roles',
  templateUrl: './user-roles.component.html',
  styleUrls: ['./user-roles.component.css']
})
export class UserRolesComponent implements OnInit {

  selectedPermissions: string[] = [];

  userRolesOptions: SelectItem[] = [];

  selectedUserRole: UserRole;

  ORG_PERMISSION_LABELS = ORG_PERMISSION_LABELS;
  PERSON_PERMISSION_LABELS = PERSON_PERMISSION_LABELS;
  NDP_PERMISSION_LABELS = NDP_PERMISSION_LABELS;
  NDP_READ_ONLY_PERMISSIONS = NDP_READ_ONLY_PERMISSIONS;
  NDP_UPDATE_ONLY_PERMISSIONS = NDP_UPDATE_ONLY_PERMISSIONS;
  ADMINISTRATION_LABELS = ADMINISTRATION_LABELS;
  READ_ONLY_ADMINISTRATION_LABELS = READ_ONLY_ADMINISTRATION_LABELS;
  NDP_NOT_CREATE_PERMISSIONS = NDP_NOT_CREATE_PERMISSIONS;
  NDP_NOT_DELETE_PERMISSIONS = NDP_NOT_DELETE_PERMISSIONS;

  constructor(private userRoleRestService: UserRolesRestService,
              private globalMessageService: GlobalMessagesService,
              private translate: TranslateService,
              private securityService: SecurityService) {
  }

  ngOnInit() {
    this.selectedPermissions = ['SELF_ASSESSMENT_CREATE'];
    this.userRoleRestService.getAllUserRoles(SystemType.DIRECTORY).subscribe(
      (userRoles: UserRole[]) => this.initUserRoles(userRoles)
    );
  }

  private initUserRoles(userRoles: UserRole[]) {
    this.userRolesOptions = [];
    for (const userRole of userRoles) {
      this.userRolesOptions.push({label: userRole.name, value: userRole});
    }
  }

  private initPermissions(userRoleId: number) {
    this.userRoleRestService.getPermissionsFor(userRoleId).subscribe(
      (permissions: string[]) => this.selectedPermissions = permissions
    );
  }

  userRoleChange(event) {
    if (!event.value) {
      return;
    }
    this.initPermissions(event.value.id);
  }

  save() {
    if (!this.selectedUserRole) {
      return;
    }
    this.userRoleRestService.updateUserRolePermissions(this.selectedUserRole.id, this.selectedPermissions).subscribe(
      (rsp: any) => {
        this.globalMessageService.showSuccessMessage(
          this.translate.instant('USER_ROLES.SAVE_SUCCESS_MESSAGE', {roleName: this.selectedUserRole.name}));
        this.securityService.refreshPermission();
      },
      (error: any) => this.globalMessageService.showErrorMessage(
        this.translate.instant('USER_ROLES.SAVE_ERROR_MESSAGE', {roleName: this.selectedUserRole.name}))
    );
  }

  discard() {
    if (!this.selectedUserRole) {
      return;
    }
    this.initPermissions(this.selectedUserRole.id);
  }

}
